import React from 'react';
import { useTranslation } from 'react-i18next';
import { Box } from '@material-ui/core';

import { NewsletterStatusEnum, SimpleNewsletter } from '@dev/ee-api/ee-api-models';
import { Alert, CopyButtonVariant, CopyButton, TertiaryButton, BasicInput, Typography } from '@dev/ee-components';
import OpenInNew from '@/services/icons/open-in-new-icon.svg';

import { AlertWrapper, BasicInputWrapper } from './styles';

export const PaidNewsletterLinkModalBody = (props: {paidNewsletter: SimpleNewsletter}): JSX.Element => {
    const { t } = useTranslation();
    const { paidNewsletter } = props;
    const isPublished = paidNewsletter.Status === NewsletterStatusEnum.Published;

    const handlePreviewPaidNewsletterClick = (): void => {
        window.open(paidNewsletter.LandingUrl, '_blank');  
    };

    const paidNewsletterLinkButtonText = {
        copy: t('copypaidnewsletterlink'),
        copied: t('copiedpaidnewsletterlink'),
    };

    return (
        <>
            {!isPublished &&
                <AlertWrapper>
                    <Alert severity='info' body={t('paidnewsletterlink_info')} />
                </AlertWrapper>
            }
            <Typography variant='body1'>{t('paidnewsletterlink_desc')}</Typography>
            <BasicInputWrapper isPublished={isPublished}>
                <BasicInput
                    defaultValue={paidNewsletter.LandingUrl}
                    readOnly={isPublished}
                    disabled={!isPublished}
                />
            </BasicInputWrapper>
            {isPublished &&
            <>
                <Box ml="4px" mb="24px">
                    <TertiaryButton
                        text={t('previewpaidnewsletter')}
                        startIcon={<OpenInNew />}
                        onClick={handlePreviewPaidNewsletterClick}
                    />
                </Box>
                <CopyButton
                    text={paidNewsletterLinkButtonText}
                    variant={CopyButtonVariant.Website}
                    valueToCopy={paidNewsletter.LandingUrl}
                    disableSentenceCase
                />
            </>
            }
        </>
    );
};
